import React, { Component } from 'react';
import { message } from 'antd';
import MachineTimersListView from '../views/MachineTimersListView';
import { base } from '../../base';

class MachineTimersListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timers: [],
        };
    }

    handleLogDelete = (id) => {
        console.log(id);
        const extraUser = this.props.extraUser;
        base.remove(`timers/${this.props.extraUser.companyid}/${id}`, function(err) {
            if (!err) {
                message.success('Timer Eliminado');
            }
        });
    }

    componentWillMount() {
        this.valuesRef = base.syncState(`timers/${this.props.extraUser.companyid}/`, {
            context: this,
            state: 'timers',
            asArray: true,
            queries: {
                orderByChild: 'machineid',
                equalTo: this.props.machineId,
            },
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.valuesRef);
    }

    render() {
        return (
            <div>
                <MachineTimersListView
                    deleteLog={this.handleLogDelete}
                    machineId={this.props.machineId}
                    user={this.props.user}
                    extraUser={this.props.extraUser}
                    timers={this.state.timers}
                />
            </div>
        );
    }
}

export default MachineTimersListContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineTimersListContainer.js